import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SecretService } from './secret.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ConfigurationServiceAPIConfiguration, ConfigurationServiceApi } from '@configuration-client';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { LoadingService } from './loading.service';

/**
 * Router AuthGuard for pages that required a logged in user
 */
@Injectable({
    providedIn: 'root'
})
export class RootPageGuard  {

    constructor(
        private loadingService: LoadingService,
        private secretService: SecretService,
        private http: HttpClient,
        private router: Router
    ) { }

    canActivate(): Observable<boolean> {

        return new Observable<boolean>((observer) => {

            const configurationAvailable: any = this.secretService.getConfiguration();

            if (!configurationAvailable
                || (!!configurationAvailable.alias && !configurationAvailable.alias.find(s => s === location.hostname))
            ) {

                const configurationApi = new ConfigurationServiceAPIConfiguration(environment.configurationServiceUrl, this.http);
                const configurationService = new ConfigurationServiceApi(configurationApi);

                configurationService.getCustomerPortalConfiguration(location.hostname)
                    .pipe(catchError(error => of(error)))
                    .subscribe((response) => {
                        if (!!response && !(response instanceof HttpErrorResponse)) {
                            this.router.navigate(['cup']);
                            observer.next(false);
                        } else {
                            this.loadingService.unsetMajorLoading();
                            observer.next(true);
                        }
                    });

            } else {

                if (!!this.secretService.getConfiguration()
                    && !!this.secretService.getConfiguration().alias
                    && !!this.secretService.getConfiguration().alias.find(s => s === location.hostname)) {
                    this.router.navigate(['cup']);
                    observer.next(false);
                } else {
                    observer.next(true);
                }

            }
        });


    }

}
